// extracted by mini-css-extract-plugin
module.exports = {"containerConfig":"areasConfig_containerConfig__qKRqZ","config":"areasConfig_config__QxtTJ","config__header":"areasConfig_config__header__2jpDH"};